<template>
    <div>
      <a-row :gutter="20">
        <a-col :span="16" class="left-panel">
          <div class="title info-row">
            数据范围选择
          </div>
          <div class="group-title info-row">
            选择表单
          </div>
          <div class="group-title info-row">
            <a-checkbox v-if="!data.id" :indeterminate="form.indeterminate" :checked="form.checkAll" @change="centerCheckChange($event,form)">
              全选
            </a-checkbox>
          </div>
          <a-checkbox-group v-model="form.checkedList" @change="onCenterCheckGroupChange($event,form)" style="width: 100%" class="info-row">
            <a-row :gutter="20">
              <a-col :span="12" v-for="(item,index) in form.dataList" :key="index">
                <a-row :gutter="20" style="margin-bottom: 10px">

                  <a-col :span="14">
                    <a-checkbox :value="item.value" class="one-row row-bottom" >
                      <a-tooltip>
                        <template slot="title">
                          {{item.name + (item.description?"—"+item.description:'')}}
                        </template>
                        {{item.name}}
                      </a-tooltip>
                    </a-checkbox>
                  </a-col>
                  <a-col :span="10">
                    <a-select v-model="form.historySelect[item.value]" placeholder="请选择" style="width: 100%" showSearch
                              :filterOption="filterOption"
                    >
                      <a-select-option :value="''">最新版（{{(historyData[item.value] || []).length}}）</a-select-option>
                      <a-select-option :value="history.versionId" v-for="history in historyData[item.value] || []" :key="history.versionId">{{history.historyCreateTime}}</a-select-option>
                    </a-select>
                  </a-col>
                </a-row>


              </a-col>
            </a-row>
          </a-checkbox-group>
        </a-col>
        <a-col :span="8" class="right-panel">
          <div class="title info-row">
            导出结构配置
          </div>
          <div class=" group-title info-row">
            导出格式：word
          </div>
          <div class="export-btn" >
            <a-button type="primary" @click="createExportHandle" :loading="loading" v-if="!data.id">导出</a-button>
          </div>
        </a-col>
      </a-row>
    </div>
</template>

<script>
  import manyCheck from '@/utils/components/manyCheck'
  import { getAction,postAction } from '@/api/manage'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: 'Type11',
    props:{
      data:{
        type:Object,
        default(){
          return {}
        }
      }
    },
    data(){
      return {
        loading:false,
        projectId:Vue.ls.get(CACHE_PROJECT_ID) ||'',
        form:{
          indeterminate:false,
          checkedList:[],
          historySelect:{},
          checkAll:true,
          dataList:[
          ],
        },
        historyData:{}
      }
    },
    mounted(){
      // this.loadData()
    },
    methods:{
      loadDataView(){
        //回显
        if(this.data.id){
          {
            const formConfig = JSON.parse(this.data.formConfig)
            this.form.checkedList = formConfig.formIds
            this.form.historySelect = formConfig.historySelect
          }
        }
      },
      loadData(){
        this.loadDataView();
        // 表单
        getAction('/project/projectForm/listAll',{projectId:this.projectId,status:'1'}).then(res=>{
          if(res.success) {
            const dataList = []
            const checkedList = []
            const historySelect = {}
            res.result.forEach(item=>{
              checkedList.push(item.id)
              dataList.push({
                value:item.id,
                name:item.name,
                description:item.description,
              })
              historySelect[item.id]=''
            })
            this.form.dataList = dataList
            if(!this.data.id){
              this.form.checkedList = checkedList
              this.form.historySelect = historySelect
            }
          }
        })
        //表单的历史版本map
        // 表单
        getAction('/project/projectForm/listHistory',{projectId:this.projectId,status:'1'}).then(res=>{
          if(res.success) {
            this.historyData = res.result
          }
        })
      },
      centerCheckChange(e,groupInfo){
        manyCheck.centerCheckChange(e,groupInfo)
      },
      onCenterCheckGroupChange(e,groupInfo,parent){
        manyCheck.onCenterCheckGroupChange(e,groupInfo,parent)
      },
      createExportHandle(){
        const formConfig = {
          formIds: this.form.checkedList,
          historySelect:this.form.historySelect
        }
        const params = {
          formConfig:JSON.stringify(formConfig),
          projectId:this.projectId,
          type:'11'
        }
        this.loading = true
        postAction('/export/projectExport/create',params).then(res=>{
          if(res.success){
            this.$emit("back")
            this.$message.success(res.message)
          }else{
            this.$message.success(res.message)
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
    }
  }
</script>

<style scoped>

</style>